module.exports = __webpack_public_path__ + "static/assets/9e87e5fa7c1f2360fc6a4cca8f132ff5.svg";